export { default as ActionBasic } from './ActionBasic'; // 页面跟的的类型
export { default as IPropsBasic } from './IPropsBasic'; // 组建的props接口
export { default as ModulesBasic, ModulesRoot } from './ModulesBasic'; // 模块基础类
export { default as UIBasic } from './UIBasic'; // UI基础类


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/modules/index.ts